<template>
  <AnalyticsModuleContainer
    :title-key="config.titleKey"
    :grid-row-span="3"
    :explore-link="config.exploreLink"
    :benchmark-link="config.benchmarkLink"
    :info-content="config.infoContent"
    :member-short-titles="getMembersFromQuery(query)"
  >
    <template v-if="!error">
      <h3
        v-if="query.limit"
        class="title"
      >
        <span>{{ $t(`dashboard.stats.top`) }}&nbsp;</span>
        <span>{{ query.limit }}</span>
      </h3>
      <div class="trend-container">
        <AnalyticsExtendedQueryRenderer
          :query="query"
          :time-option="{ type: QueryTimeType.PERIOD }"
          @hide-module="hideModule"
        >
          <template #default="{ queryResults }">
            <AnalyticsRendererTrend
              :query-results="queryResults"
              :fill-missing-data="true"
              :trend-type="TREND_TYPE.DISTRIBUTION"
              legend-position="bottom"
            />
          </template>
        </AnalyticsExtendedQueryRenderer>
      </div>
    </template>
    <AnalyticsModuleErrorTemplate
      v-if="error"
      :error="error"
    />
  </AnalyticsModuleContainer>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { TREND_TYPE } from '~/constants/renderTypes'
import type { TranslationKeys } from '~/plugins/i18n'
import { getMembersFromQuery } from '~/services/analytics'
import { useAnalyticsStore } from '~/stores/analytics'
import {
  type ModuleExplorerLink,
  type ModuleInfoContent,
  type ModuleBenchmarkLink,
  QueryTimeType,
  type Filter
} from '~/types/analytics'
import type { Order } from '~/types/cube'

type DistributionModuleConfig = {
  titleKey: TranslationKeys
  exploreLink?: ModuleExplorerLink
  benchmarkLink?: ModuleBenchmarkLink
  infoContent?: ModuleInfoContent
}

type DistributionModuleQuery = {
  measures: [string]
  dimensions: [string]
  filters?: Filter[]
  order?: Order[] | undefined
  limit: number
}

export default {
  name: 'ModuleComponentsDistribution',
  props: {
    query: {
      type: Object as PropType<DistributionModuleQuery>,
      required: true
    },
    config: {
      type: Object as PropType<DistributionModuleConfig>,
      required: true
    }
  },
  setup() {
    return {
      TREND_TYPE,
      QueryTimeType,
      getMembersFromQuery
    }
  },
  data(): { error: Error | undefined } {
    return {
      error: undefined
    }
  },
  computed: {
    ...mapState(useAnalyticsStore, ['analyticsParams'])
  },
  watch: {
    analyticsParams: {
      handler() {
        this.error = undefined
      }
    }
  },
  methods: {
    hideModule(error: any) {
      this.error = error
    }
  }
}
</script>

<style lang="scss" scoped>
.trend-container {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.title {
  @include font-title;
  @include font-size($font-size-large);
  color: $text-primary;
}
</style>
